import React, { useEffect } from 'react';
import { OnboardingState } from '@/types/onboarding';
import { OnboardingWizard } from './OnboardingWizard';
import { MobileOnboardingWizard } from './MobileOnboardingWizard';
import { useIsMobile } from '@/hooks/use-is-mobile';

interface ResponsiveOnboardingWizardProps {
  userId: string;
  currentState: OnboardingState;
  onStepComplete: (stepId: string, data: Record<string, any>) => void;
  onNavigateToStep?: (stepNumber: number) => void;
  allowNavigation?: boolean;
}

/**
 * Componente que seleciona automaticamente entre o OnboardingWizard desktop
 * e mobile baseado no tamanho da tela.
 */
export const ResponsiveOnboardingWizard: React.FC<ResponsiveOnboardingWizardProps> = (props) => {
  // Usar o hook especializado para detectar dispositivos móveis
  const isMobile = useIsMobile();
  
  // Verificar se a função onNavigateToStep está sendo passada corretamente
  useEffect(() => {
    console.log("ResponsiveOnboardingWizard: props recebidas:", {
      userId: props.userId,
      currentStep: props.currentState?.current_step,
      hasNavigateFunction: !!props.onNavigateToStep,
      allowNavigation: props.allowNavigation
    });
  }, [props]);
  
  // Adicionar um handler para navegar entre etapas que faz log
  const handleNavigateToStep = (stepNumber: number) => {
    console.log("ResponsiveOnboardingWizard: handleNavigateToStep chamado com stepNumber:", stepNumber);
    if (props.onNavigateToStep) {
      console.log("ResponsiveOnboardingWizard: Repassando a chamada para props.onNavigateToStep");
      props.onNavigateToStep(stepNumber);
    } else {
      console.error("ResponsiveOnboardingWizard: props.onNavigateToStep não está definida!");
    }
  };
  
  // Renderizar o componente adequado com base no tamanho da tela
  if (isMobile) {
    return (
      <MobileOnboardingWizard 
        {...props}
        onNavigateToStep={handleNavigateToStep}
      />
    );
  }
  
  return <OnboardingWizard {...props} />;
}; 